module.exports = __webpack_public_path__ + "img/首页-res@2x.5f461e57.png";